module.exports = __webpack_public_path__ + "img/85.c878d9d8.svg";